import React from 'react';
import moment from "moment";
import dayjs from 'dayjs';


export const CustomToolbar = (toolbar) => {
  const currentView=toolbar.view;
  const toolbarYear=dayjs(toolbar.date).year()
  const splitDates = toolbar.label.split("–").map(date => date.trim());
  const currentYear=dayjs().year()
  const goToBack = () => {
    toolbar.onNavigate('PREV');
  };

  const goToNext = () => {
    toolbar.onNavigate('NEXT');
  };

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY');
  };

  // const label = () => {
   
  //   const date = toolbar.label;
  //   console.log("date",date.split(" "));
  //   const parts = date.split(" ");
  //   return (
  //     if(!parts[1]){
  //       <span>
  //      {date}{", "}{
  //       currentView==='week' && (toolbarYear)
  //      }
  //     </span>
  //     }else{
  //     <span>
  //      {parts[1]+" "+parts[2]+" "+parts[3]+" "+parts[0]}{", "}{
  //       currentView==='week' && (toolbarYear)
  //      }
  //     </span>
  //     }
  //   );
  // };

  const label = () => {
    const date = toolbar.label;
    const parts = date.split(" ");
     
    return (
      <span>
        
        {date}
        {currentView === 'week' && toolbarYear ? `, ${toolbarYear}` : ''}
      </span>
    );
  };
  

  // const label = () => {
  //   const label = toolbar.label; // e.g. "May 18 – 24 2025"
  
  //   // Split the string by spaces
  //   const parts = label.split(" "); // ["May", "18", "–", "24", "2025"]
  
  //   if (parts.length < 5) return <span>{label}</span>;
  
  //   const month = parts[0];        // "May"
  //   const startDay = parts[1];     // "18"
  //   const endDay = parts[3];       // "24"
  //   const year = parts[4];         // "2025"
  
  //   const formatted = `${startDay}–${endDay} ${month}, ${year}`;
  
  //   return <span>{formatted}</span>;
  // };
  


  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button type="button" onClick={goToBack}>Previous</button>
        <button type="button" onClick={goToCurrent}>Current</button>
        <button type="button" onClick={goToNext}>Next</button>
      </span>
      <span className="rbc-toolbar-label">{label()}</span>
    </div>
  );
};

